<template>
  <button
    class="control-button"
    @click="emit('click')"
    :aria-label="t('player.controls.forward10')"
    :data-tooltip="t('player.controls.forward10') + ' (l)'"
    v-html="forward10Icon"
  />
</template>

<script setup lang="ts">
import { forward10Icon } from '../../assets/icons'
import { useVideoI18n } from '../../i18n'

const emit = defineEmits<{
  click: []
}>()

const { t } = useVideoI18n()
</script>

<style scoped>
/* Styles are in main.scss */
</style>
